import { LuPencilLine } from 'react-icons/lu';
import { MdShowChart } from 'react-icons/md';
import type { Forecast } from '../../schema';

interface Props {
  row: Forecast;
  onEdit: (row: Forecast) => void;
  onChart: (row: Forecast) => void;
}

// Two icon buttons: chart (drill into per-series visualization) + edit
// (toggle is_active / edit notes). No delete — pipeline owns deletion.
export function ForecastRowActions({ row, onEdit, onChart }: Props) {
  return (
    <div className="row-actions flex h-full items-center justify-center gap-2">
      <button
        type="button"
        onClick={() => onChart(row)}
        aria-label={`Chart ${row.cropName} ${row.metric} ${row.horizonDays}d`}
        title="View chart"
        className="group flex h-8 w-8 shrink-0 items-center justify-center self-center rounded-lg bg-secondary/[0.08] text-secondary ring-1 ring-inset ring-secondary/15 transition-all duration-200 hover:scale-110 hover:bg-secondary hover:text-secondary-foreground hover:shadow-[0_4px_12px_-2px_rgb(var(--color-secondary)/0.4)]"
      >
        <MdShowChart size={17} />
      </button>
      <button
        type="button"
        onClick={() => onEdit(row)}
        aria-label={`Edit forecast ${row.id}`}
        title="Edit"
        className="group flex h-8 w-8 shrink-0 items-center justify-center self-center rounded-lg bg-primary/[0.08] text-primary ring-1 ring-inset ring-primary/15 transition-all duration-200 hover:scale-110 hover:bg-primary hover:text-primary-foreground hover:shadow-[0_4px_12px_-2px_rgb(var(--color-primary)/0.4)]"
      >
        <LuPencilLine size={15} strokeWidth={2.2} />
      </button>
    </div>
  );
}
